/* unplugin-vue-components disabled */import script from "./PointDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PointDialog.vue?vue&type=script&setup=true&lang=js"

import "./PointDialog.vue?vue&type=style&index=0&id=bd9ae256&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd9ae256"]])

export default __exports__